export default __webpack_public_path__ + "238bad83615cf351cc17de386eaffba4.svg";